"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Recorder = (function () {
    function Recorder(options) {
        if (options === void 0) { options = {}; }
        this.isplaying = false;
        this.lBuffer = [];
        this.rBuffer = [];
        this.tempPCM = [];
        this.inputSampleBits = 16;
        this.playStamp = 0;
        this.playTime = 0;
        this.offset = 0;
        this.totalRawLength = 0;
        this.fileSize = 0;
        var context = new (window.AudioContext || window.webkitAudioContext)();
        this.inputSampleRate = context.sampleRate;
        this.config = {
            sampleBits: ~[8, 16].indexOf(options.sampleBits) ? options.sampleBits : 16,
            sampleRate: ~[11025, 16000, 22050, 24000, 44100, 48000].indexOf(options.sampleRate)
                ? options.sampleRate
                : this.inputSampleRate,
            numChannels: ~[1, 2].indexOf(options.numChannels) ? options.numChannels : 1,
            compiling: !!options.compiling || false
        };
        this.outputSampleRate = this.config.sampleRate;
        this.oututSampleBits = this.config.sampleBits;
        this.littleEdian = (function () {
            var buffer = new ArrayBuffer(2);
            new DataView(buffer).setInt16(0, 256, true);
            return new Int16Array(buffer)[0] === 256;
        })();
        this.initUserMedia();
    }
    Recorder.prototype.initRecorder = function () {
        var _this = this;
        if (this.context) {
            this.destroy();
        }
        this.context = new (window.AudioContext || window.webkitAudioContext)();
        this.analyser = this.context.createAnalyser();
        this.analyser.fftSize = 2048;
        var createScript = this.context.createScriptProcessor || this.context.createJavaScriptNode;
        this.recorder = createScript.apply(this.context, [0, this.config.numChannels, this.config.numChannels]);
        this.recorder.onaudioprocess = function (e) {
            if (!_this.isrecording || _this.ispause) {
                return;
            }
            var lData = e.inputBuffer.getChannelData(0), rData = null, vol = 0;
            _this.lBuffer.push(new Float32Array(lData));
            _this.size += lData.length;
            if (_this.config.numChannels === 2) {
                rData = e.inputBuffer.getChannelData(1);
                _this.rBuffer.push(new Float32Array(rData));
                _this.size += rData.length;
            }
            if (_this.config.compiling) {
                var pcm = _this.transformIntoPCM(lData, rData);
                _this.tempPCM.push(pcm);
                _this.fileSize = pcm.byteLength * _this.tempPCM.length;
            }
            else {
                _this.fileSize =
                    Math.floor(_this.size / Math.max(_this.inputSampleRate / _this.outputSampleRate, 1)) *
                        (_this.oututSampleBits / 8);
            }
            vol = Math.max.apply(Math, lData) * 100;
            _this.totalRawLength += lData.byteLength;
            _this.duration = (_this.totalRawLength / (4 * _this.inputSampleRate));
            _this.onprocess && _this.onprocess(_this.duration);
            _this.onprogress &&
                _this.onprogress({
                    duration: _this.duration,
                    fileSize: _this.fileSize,
                    vol: vol,
                    raw: lData,
                    data: _this.tempPCM
                });
        };
    };
    Recorder.prototype.start = function () {
        var _this = this;
        if (this.isrecording) {
            return;
        }
        this.clear();
        this.initRecorder();
        this.isrecording = true;
        return navigator.mediaDevices
            .getUserMedia({
            audio: true
        })
            .then(function (stream) {
            _this.audioInput = _this.context.createMediaStreamSource(stream);
        })
            .then(function () {
            _this.audioInput.connect(_this.analyser);
            _this.analyser.connect(_this.recorder);
            _this.recorder.connect(_this.context.destination);
        });
    };
    Recorder.prototype.check = function () {
        return navigator.mediaDevices
            .getUserMedia({
            audio: true
        });
    };
    Recorder.prototype.pause = function () {
        if (this.isrecording && !this.ispause) {
            this.ispause = true;
            this.recorder.disconnect();
        }
    };
    Recorder.prototype.resume = function () {
        if (this.isrecording && this.ispause) {
            this.ispause = false;
            this.audioInput && this.audioInput.connect(this.analyser);
            this.analyser.connect(this.recorder);
            this.recorder.connect(this.context.destination);
        }
    };
    Recorder.prototype.stop = function () {
        this.isrecording = false;
        this.audioInput && this.audioInput.disconnect();
        this.recorder && this.recorder.disconnect();
    };
    Recorder.prototype.play = function () {
        this.stop();
        this.source && this.source.stop();
        this.isplaying = true;
        this.playTime = 0;
        this.playAudioData();
    };
    Recorder.prototype.pausePlay = function () {
        if (this.isrecording || !this.isplaying) {
            return;
        }
        this.source && this.source.disconnect();
        this.playTime += this.context.currentTime - this.playStamp;
        this.isplaying = false;
    };
    Recorder.prototype.resumePlay = function () {
        if (this.isrecording || this.isplaying || this.playTime === 0) {
            return;
        }
        this.isplaying = true;
        this.playAudioData();
    };
    Recorder.prototype.stopPlay = function () {
        if (this.isrecording) {
            return;
        }
        this.playTime = 0;
        this.isplaying = false;
        this.source && this.source.stop();
    };
    Recorder.prototype.getWholeData = function () {
        return this.tempPCM;
    };
    Recorder.prototype.getNextData = function () {
        var length = this.tempPCM.length, data = this.tempPCM.slice(this.offset);
        this.offset = length;
        return data;
    };
    Recorder.prototype.playAudioData = function () {
        var _this = this;
        this.context.decodeAudioData(this.getWAV().buffer, function (buffer) {
            _this.source = _this.context.createBufferSource();
            _this.source.buffer = buffer;
            _this.source.connect(_this.analyser);
            _this.analyser.connect(_this.context.destination);
            _this.source.start(0, _this.playTime);
            _this.playStamp = _this.context.currentTime;
        }, function (e) {
            Recorder.throwError(e);
        });
    };
    Recorder.prototype.getRecordAnalyseData = function () {
        if (this.ispause) {
            return this.prevDomainData;
        }
        var dataArray = new Uint8Array(this.analyser.frequencyBinCount);
        this.analyser.getByteTimeDomainData(dataArray);
        return (this.prevDomainData = dataArray);
    };
    Recorder.prototype.getPlayAnalyseData = function () {
        return this.getRecordAnalyseData();
    };
    Recorder.prototype.initUserMedia = function () {
        if (navigator.mediaDevices === undefined) {
            navigator.mediaDevices = {};
        }
        if (navigator.mediaDevices.getUserMedia === undefined) {
            navigator.mediaDevices.getUserMedia = function (constraints) {
                var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                if (!getUserMedia) {
                    return Promise.reject(new Error('浏览器不支持 getUserMedia !'));
                }
                return new Promise(function (resolve, reject) {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
            };
        }
    };
    Recorder.prototype.getPCM = function () {
        if (this.tempPCM.length) {
            var buffer = new ArrayBuffer(this.tempPCM.length * this.tempPCM[0].byteLength), pcm_1 = new DataView(buffer), offset_1 = 0;
            this.tempPCM.forEach(function (block) {
                for (var i = 0, len = block.byteLength; i < len; ++i) {
                    pcm_1.setInt8(offset_1, block.getInt8(i));
                    offset_1++;
                }
            });
            this.PCM = pcm_1;
            this.tempPCM = [];
        }
        if (this.PCM) {
            return this.PCM;
        }
        var data = this.flat();
        data = Recorder.compress(data, this.inputSampleRate, this.outputSampleRate);
        return (this.PCM = Recorder.encodePCM(data, this.oututSampleBits, this.littleEdian));
    };
    Recorder.prototype.getPCMBlob = function () {
        this.stop();
        return new Blob([this.getPCM()]);
    };
    Recorder.prototype.downloadPCM = function (name) {
        if (name === void 0) { name = 'recorder'; }
        var pcmBlob = this.getPCMBlob();
        this.download(pcmBlob, name, 'pcm');
    };
    Recorder.prototype.getWAV = function () {
        var pcmTemp = this.getPCM(), wavTemp = Recorder.encodeWAV(pcmTemp, this.inputSampleRate, this.outputSampleRate, this.config.numChannels, this.oututSampleBits, this.littleEdian);
        return wavTemp;
    };
    Recorder.prototype.getWAVBlob = function () {
        this.stop();
        return new Blob([this.getWAV()], { type: 'audio/wav' });
    };
    Recorder.prototype.downloadWAV = function (name) {
        if (name === void 0) { name = 'recorder'; }
        var wavBlob = this.getWAVBlob();
        this.download(wavBlob, name, 'wav');
    };
    Recorder.prototype.transformIntoPCM = function (lData, rData) {
        var lBuffer = new Float32Array(lData), rBuffer = new Float32Array(rData);
        var data = Recorder.compress({
            left: lBuffer,
            right: rBuffer
        }, this.inputSampleRate, this.outputSampleRate);
        return Recorder.encodePCM(data, this.oututSampleBits, this.littleEdian);
    };
    Recorder.prototype.destroy = function () {
        return this.closeAudioContext();
    };
    Recorder.prototype.closeAudioContext = function () {
        if (this.context.close) {
            return this.context.close();
        }
        return new Promise(function (resolve) {
            resolve();
        });
    };
    Recorder.prototype.download = function (blob, name, type) {
        try {
            var oA = document.createElement('a');
            oA.href = window.URL.createObjectURL(blob);
            oA.download = name + '.' + type;
            oA.click();
        }
        catch (e) {
            Recorder.throwError(e);
        }
    };
    Recorder.prototype.clear = function () {
        this.lBuffer.length = 0;
        this.rBuffer.length = 0;
        this.size = 0;
        this.fileSize = 0;
        this.PCM = null;
        this.audioInput = null;
        this.duration = 0;
        this.ispause = false;
        this.isplaying = false;
        this.playTime = 0;
        this.totalRawLength = 0;
        if (this.source) {
            this.source.stop();
            this.source = null;
        }
    };
    Recorder.prototype.flat = function () {
        var lData = null, rData = new Float32Array(0);
        if (this.config.numChannels === 1) {
            lData = new Float32Array(this.size);
        }
        else {
            lData = new Float32Array(this.size / 2);
            rData = new Float32Array(this.size / 2);
        }
        var offset = 0;
        for (var i = 0; i < this.lBuffer.length; i++) {
            lData.set(this.lBuffer[i], offset);
            offset += this.lBuffer[i].length;
        }
        offset = 0;
        for (var i = 0; i < this.rBuffer.length; i++) {
            rData.set(this.rBuffer[i], offset);
            offset += this.rBuffer[i].length;
        }
        return {
            left: lData,
            right: rData
        };
    };
    Recorder.playAudio = function (blob) {
        var oAudio = document.createElement('audio');
        oAudio.src = window.URL.createObjectURL(blob);
        oAudio.play();
    };
    Recorder.compress = function (data, inputSampleRate, outputSampleRate) {
        var rate = inputSampleRate / outputSampleRate, compression = Math.max(rate, 1), lData = data.left, rData = data.right, length = Math.floor((lData.length + rData.length) / rate), result = new Float32Array(length), index = 0, j = 0;
        while (index < length) {
            var temp = Math.floor(j);
            result[index] = lData[temp];
            index++;
            if (rData.length) {
                result[index] = rData[temp];
                index++;
            }
            j += compression;
        }
        return result;
    };
    Recorder.encodePCM = function (bytes, sampleBits, littleEdian) {
        if (littleEdian === void 0) { littleEdian = true; }
        var offset = 0, dataLength = bytes.length * (sampleBits / 8), buffer = new ArrayBuffer(dataLength), data = new DataView(buffer);
        if (sampleBits === 8) {
            for (var i = 0; i < bytes.length; i++, offset++) {
                var s = Math.max(-1, Math.min(1, bytes[i]));
                var val = s < 0 ? s * 128 : s * 127;
                val = +val + 128;
                data.setInt8(offset, val);
            }
        }
        else {
            for (var i = 0; i < bytes.length; i++, offset += 2) {
                var s = Math.max(-1, Math.min(1, bytes[i]));
                data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, littleEdian);
            }
        }
        return data;
    };
    Recorder.encodeWAV = function (bytes, inputSampleRate, outputSampleRate, numChannels, oututSampleBits, littleEdian) {
        if (littleEdian === void 0) { littleEdian = true; }
        var sampleRate = outputSampleRate > inputSampleRate ? inputSampleRate : outputSampleRate, sampleBits = oututSampleBits, buffer = new ArrayBuffer(44 + bytes.byteLength), data = new DataView(buffer), channelCount = numChannels, offset = 0;
        writeString(data, offset, 'RIFF');
        offset += 4;
        data.setUint32(offset, 36 + bytes.byteLength, littleEdian);
        offset += 4;
        writeString(data, offset, 'WAVE');
        offset += 4;
        writeString(data, offset, 'fmt ');
        offset += 4;
        data.setUint32(offset, 16, littleEdian);
        offset += 4;
        data.setUint16(offset, 1, littleEdian);
        offset += 2;
        data.setUint16(offset, channelCount, littleEdian);
        offset += 2;
        data.setUint32(offset, sampleRate, littleEdian);
        offset += 4;
        data.setUint32(offset, channelCount * sampleRate * (sampleBits / 8), littleEdian);
        offset += 4;
        data.setUint16(offset, channelCount * (sampleBits / 8), littleEdian);
        offset += 2;
        data.setUint16(offset, sampleBits, littleEdian);
        offset += 2;
        writeString(data, offset, 'data');
        offset += 4;
        data.setUint32(offset, bytes.byteLength, littleEdian);
        offset += 4;
        for (var i = 0; i < bytes.byteLength;) {
            data.setUint8(offset, bytes.getUint8(i));
            offset++;
            i++;
        }
        return data;
    };
    Recorder.throwError = function (message) {
        throw new Error(message);
    };
    return Recorder;
}());
function writeString(data, offset, str) {
    for (var i = 0; i < str.length; i++) {
        data.setUint8(offset + i, str.charCodeAt(i));
    }
}
exports.default = Recorder;
//# sourceMappingURL=recorder.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/audio/recorder.js
// module id = uJdc
// module chunks = 0